import api from '@/api';
import {
	ForexTemplateFilter,
	ForexTemplateItem,
	ForexTemplateWithDraft
} from '@/feature/TrHistory/api/template/forex-template.interface';
import { isSuccessResponseStatusCode } from '@/api/handler';
import { IApiHandlerParams } from '@/api/interface';

export const $getForexTemplateList = async (
	params?: ForexTemplateFilter,
	handler: IApiHandlerParams = { disableLoader: true }
): Promise<ForexTemplateItem[]> => {
	return api
		.get('foreign-exchange/template/list', {
			request: { params },
			handler
		})
		.then(response => response?.data || []);
};

export const $updateForexTemplate = async (
	template?: ForexTemplateWithDraft
): Promise<boolean> => {
	return api
		.patch('foreign-exchange/template', template, {
			handler: { returnData: false }
		})
		.then(response => isSuccessResponseStatusCode(response?.status));
};

export const $deleteForexTemplate = async (
	id: number
): Promise<boolean> => {
	return api
		.delete('foreign-exchange/template/' + id, {
			handler: { returnData: false }
		})
		.then(response => isSuccessResponseStatusCode(response?.status));
};

export const $createForexTemplate = async (
	template?: ForexTemplateWithDraft
): Promise<ForexTemplateWithDraft> => {
	return api.post('foreign-exchange/template', template);
};

export const $getForexTemplateById = async (
	id: number
): Promise<ForexTemplateWithDraft | null> => {
	return api.get('foreign-exchange/template/' + id);
};
